import React from "react";
import { Dropdown } from "primereact/dropdown";
type BaseSelectProp = {
  styleClass: string;
  textClass: string;
  value: { id: string; name: string };
  label: string;
  name: string;
  selectKey: string;
  filter: boolean;
  showClear?: boolean;
  inputId?: string;
  options: Array<{ id: string | number; name: string }>;
  hasError?: boolean;
  errorMsg?: string;
  onChange: (e: any) => void;
  disabled?: boolean;
};

const BaseSelect: React.FC<BaseSelectProp> = ({
  styleClass = "",
  textClass = "",
  value = null,
  label,
  name,
  selectKey,
  filter = false,
  showClear = false,
  inputId,
  options,
  disabled = false,
  hasError = false,
  onChange,
  errorMsg = "",
}) => {
  return (
    <div className="relative">
      <span className="p-float-label">
        <Dropdown
          name={name}
          inputId={inputId}
          value={value}
          options={options}
          onChange={(e) => onChange(e.value)}
          optionLabel={selectKey}
        
          className={`${styleClass} h-[56px] rounded-lg border opacity-75 font-[500] !bg-[#F9FAFC] !focus:ring-0 !focus:border-0 !focus:outline-none w-full text-[#767B86] font-[400] focus:border-[#A0A1B9]  ${
            disabled &&
            "border !border-[#A0A1B9] !opacity-50 cursor-not-allowed"
          }`}
            showClear={showClear}
          filter={filter}
          disabled={disabled}
        />
        <label
          htmlFor={inputId}
          className={`absolute pl-2 z-[1] text-[1.2rem] font-[500] text-[#767B86] dark:text-[#575A65] duration-300 transform -translate-y-[0.6rem] scale-75 origin-[0] left-2.5 peer-focus:text-[#575A65] peer-focus:dark:text-[#575A65] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-[0.6rem] ${value?.id !== "" ? "top-6 text-[15px]" : "top-9"}`}

        >
          {label}
        </label>
      </span>
      {hasError && (
        <p className="text-[#F85359] text-[12px] pt-1">{errorMsg}</p>
      )}
    </div>
  );
};
export default BaseSelect;
